const initialState = {
    statusShow: false,
    transactions:{},
    total:0,
    total_rows:0,
    offset:0,
    loader:false,
};
const modalMyCarrotWallet = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_MY_CARROT_WALLET':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_MY_CARROT_WALLET':
            return {...state, statusShow: false};
        case 'CHANGE_DATA_CARROT_WALLET':
            return {
                ...state,
                transactions: action.transactions,
                total: action.total,
                total_rows: action.total_rows,
                offset: action.offset
            };
        case 'CHANGE_LOADER_MODAL_CARROT_WALLET':
            return{...state,loader:action.loader};
        default:
            return state;
    }
};

export default modalMyCarrotWallet;